import resolveExpression from '../../expressionParser/resolveExpression';
import moment from 'moment';
import dotNotationMapper from '../../../../data/dotNotationMapper';
import dotNotationObjectUpdate from '../../../../data/dotNotationObjectUpdate';

export default function (
    currentValue, method={},
    variableObject={}, parameterObject={},
    functionMap={}, variableIdMap={}
){
    try{
        const {
            methodData={}, methodName=''
        } = method;

        let updatedVariableObject = variableObject;
        let returnValue;
        if(methodName === 'slice'){
            let startIndexResponse = resolveExpression(
                methodData['startIndex'], updatedVariableObject,
                parameterObject, functionMap, variableIdMap
            )
            updatedVariableObject = startIndexResponse.variableObject;
            let endIndexResponse = resolveExpression(
                methodData['endIndex'], updatedVariableObject,
                parameterObject, functionMap, variableIdMap
            );
            updatedVariableObject = endIndexResponse.variableObject;
            returnValue = currentValue.slice(
                startIndexResponse.value,
                endIndexResponse.value
            );
        }else if(methodName === 'substring'){
            let startIndexResponse = resolveExpression(
                methodData['startIndex'], updatedVariableObject,
                parameterObject, functionMap, variableIdMap
            )
            updatedVariableObject = startIndexResponse.variableObject;
            let endIndexResponse = resolveExpression(
                methodData['endIndex'], updatedVariableObject,
                parameterObject, functionMap, variableIdMap
            );
            updatedVariableObject = endIndexResponse.variableObject;
            returnValue = currentValue.substring(
                startIndexResponse.value,
                endIndexResponse.value
            );
        }else if(methodName === 'replace'){
            let stringToReplace = resolveExpression(
                methodData['stringToReplace'], updatedVariableObject,
                parameterObject, functionMap, variableIdMap
            )
            updatedVariableObject = stringToReplace.variableObject;
            let replacementString = resolveExpression(
                methodData['replacementString'], updatedVariableObject,
                parameterObject, functionMap, variableIdMap
            );
            updatedVariableObject = replacementString.variableObject;
            returnValue = currentValue.replace(
                stringToReplace.value,
                replacementString.value
            );
        }else if(methodName === 'stringToPEM'){
            if(typeof currentValue === 'string'){
                let firstLineText = resolveExpression(
                    methodData['firstLineText'], updatedVariableObject,
                    parameterObject, functionMap, variableIdMap
                )
                updatedVariableObject = firstLineText.variableObject;
                let lastLineText = resolveExpression(
                    methodData['lastLineText'], updatedVariableObject,
                    parameterObject, functionMap, variableIdMap
                );
                updatedVariableObject = lastLineText.variableObject;

                let replace1 = currentValue.replace(firstLineText.value, '');
                let replace2 = replace1.replace(lastLineText.value, '');
                let trimmedString = replace2.trim();
                trimmedString = trimmedString.replaceAll(' ', '');
                let PEM = ``
                PEM += `${firstLineText.value}\n`;
                while(trimmedString.length > 0) {
                    PEM += trimmedString.substring(0, 64) + '\n';
                    trimmedString = trimmedString.substring(64);
                }
                PEM += lastLineText.value;
                returnValue = PEM;
            }else{
                returnValue = currentValue;
            }
        }else if(methodName === 'setFullYear'){
            let year = resolveExpression(
                methodData['year'], updatedVariableObject,
                parameterObject, functionMap, variableIdMap
            )
            updatedVariableObject = year.variableObject;
            let month = resolveExpression(
                methodData['month'], updatedVariableObject,
                parameterObject, functionMap, variableIdMap
            );
            updatedVariableObject = month.variableObject;
            let day = resolveExpression(
                methodData['day'], updatedVariableObject,
                parameterObject, functionMap, variableIdMap
            );
            updatedVariableObject = day.variableObject;
            returnValue = new Date(currentValue).setFullYear(
                year.value,
                month.value,
                day.value
            )
        }else if(methodName === 'setHours'){
            let hour = resolveExpression(
                methodData['hour'], updatedVariableObject,
                parameterObject, functionMap, variableIdMap
            )
            updatedVariableObject = hour.variableObject;
            let min = resolveExpression(
                methodData['min'], updatedVariableObject,
                parameterObject, functionMap, variableIdMap
            );
            updatedVariableObject = min.variableObject;
            let sec = resolveExpression(
                methodData['sec'], updatedVariableObject,
                parameterObject, functionMap, variableIdMap
            );
            updatedVariableObject = sec.variableObject;
            let milliseconds = resolveExpression(
                methodData['milliseconds'], updatedVariableObject,
                parameterObject, functionMap, variableIdMap
            );
            updatedVariableObject = milliseconds.variableObject;

            returnValue = new Date(currentValue).setHours(
                hour.value,
                min.value,
                sec.value,
                milliseconds.value
            )
        }else if(methodName === 'setMinutes'){
            let min = resolveExpression(
                methodData['min'], updatedVariableObject,
                parameterObject, functionMap, variableIdMap
            );
            updatedVariableObject = min.variableObject;
            let sec = resolveExpression(
                methodData['sec'], updatedVariableObject,
                parameterObject, functionMap, variableIdMap
            );
            updatedVariableObject = sec.variableObject;
            let milliseconds = resolveExpression(
                methodData['milliseconds'], updatedVariableObject,
                parameterObject, functionMap, variableIdMap
            );
            updatedVariableObject = milliseconds.variableObject;

            returnValue = new Date(currentValue).setMinutes(
                min.value,
                sec.value,
                milliseconds.value
            )
        }else if(methodName === 'setMonth'){
            let month = resolveExpression(
                methodData['month'], updatedVariableObject,
                parameterObject, functionMap, variableIdMap
            );
            updatedVariableObject = month.variableObject;
            let day = resolveExpression(
                methodData['day'], updatedVariableObject,
                parameterObject, functionMap, variableIdMap
            );
            updatedVariableObject = day.variableObject;
            returnValue = new Date(currentValue).setMonth(
                month.value,
                day.value
            )
        }else if(methodName === 'setSeconds'){
            let seconds = resolveExpression(
                methodData['seconds'], updatedVariableObject,
                parameterObject, functionMap, variableIdMap
            );
            updatedVariableObject = seconds.variableObject;
            let milliseconds = resolveExpression(
                methodData['milliseconds'], updatedVariableObject,
                parameterObject, functionMap, variableIdMap
            );
            updatedVariableObject = milliseconds.variableObject;
            returnValue = new Date(currentValue).setSeconds(
                seconds.value,
                milliseconds.value
            )
        }else if(methodName === 'setUTCFullYear'){
            let year = resolveExpression(
                methodData['year'], updatedVariableObject,
                parameterObject, functionMap, variableIdMap
            )
            updatedVariableObject = year.variableObject;
            let month = resolveExpression(
                methodData['month'], updatedVariableObject,
                parameterObject, functionMap, variableIdMap
            );
            updatedVariableObject = month.variableObject;
            let day = resolveExpression(
                methodData['day'], updatedVariableObject,
                parameterObject, functionMap, variableIdMap
            );
            updatedVariableObject = day.variableObject;
            returnValue = new Date(currentValue).setUTCFullYear(
                year.value,
                month.value,
                day.value
            )
        }else if(methodName === 'setUTCHours'){
            let hour = resolveExpression(
                methodData['hour'], updatedVariableObject,
                parameterObject, functionMap, variableIdMap
            )
            updatedVariableObject = hour.variableObject;
            let min = resolveExpression(
                methodData['min'], updatedVariableObject,
                parameterObject, functionMap, variableIdMap
            );
            updatedVariableObject = min.variableObject;
            let sec = resolveExpression(
                methodData['sec'], updatedVariableObject,
                parameterObject, functionMap, variableIdMap
            );
            updatedVariableObject = sec.variableObject;
            let milliseconds = resolveExpression(
                methodData['milliseconds'], updatedVariableObject,
                parameterObject, functionMap, variableIdMap
            );
            updatedVariableObject = milliseconds.variableObject;
            returnValue = new Date(currentValue).setUTCHours(
                hour.value,
                min.value,
                sec.value,
                milliseconds.value
            )
        }else if(methodName === 'setUTCMinutes'){
            let min = resolveExpression(
                methodData['min'], updatedVariableObject,
                parameterObject, functionMap, variableIdMap
            );
            updatedVariableObject = min.variableObject;
            let sec = resolveExpression(
                methodData['sec'], updatedVariableObject,
                parameterObject, functionMap, variableIdMap
            );
            updatedVariableObject = sec.variableObject;
            let milliseconds = resolveExpression(
                methodData['milliseconds'], updatedVariableObject,
                parameterObject, functionMap, variableIdMap
            );
            updatedVariableObject = milliseconds.variableObject;
            returnValue = new Date(currentValue).setUTCMinutes(
                min.value,
                sec.value,
                milliseconds.value
            )
        }else if(methodName === 'setUTCMonth'){
            let month = resolveExpression(
                methodData['month'], updatedVariableObject,
                parameterObject, functionMap, variableIdMap
            );
            updatedVariableObject = month.variableObject;
            let day = resolveExpression(
                methodData['day'], updatedVariableObject,
                parameterObject, functionMap, variableIdMap
            );
            updatedVariableObject = day.variableObject;
            returnValue = new Date(currentValue).setUTCMonth(
                month.value,
                day.value
            )
        }else if(methodName === 'setUTCSeconds'){
            let seconds = resolveExpression(
                methodData['seconds'], updatedVariableObject,
                parameterObject, functionMap, variableIdMap
            );
            updatedVariableObject = seconds.variableObject;
            let milliseconds = resolveExpression(
                methodData['milliseconds'], updatedVariableObject,
                parameterObject, functionMap, variableIdMap
            );
            updatedVariableObject = milliseconds.variableObject;
            returnValue = new Date(currentValue).setUTCSeconds(
                seconds.value,
                milliseconds.value
            )
        }else if(['addDate', 'subtractDate'].includes(methodName)){
            let number = resolveExpression(
                methodData['number'], updatedVariableObject,
                parameterObject, functionMap, variableIdMap
            );
            updatedVariableObject = number.variableObject;
            let duration = resolveExpression(
                methodData['duration'], updatedVariableObject,
                parameterObject, functionMap, variableIdMap
            );
            updatedVariableObject = duration.variableObject;
            if(methodName === 'addDate'){
                returnValue = moment(currentValue).add(number.value, duration.value);
            }else{
                returnValue = moment(currentValue).subtract(number.value, duration.value);
            }
        }else if(methodName === 'dotNotationMap'){
            let path = resolveExpression(
                methodData['path'], updatedVariableObject,
                parameterObject, functionMap, variableIdMap
            );
            updatedVariableObject = path.variableObject;
            let fallbackValue = resolveExpression(
                methodData['fallbackValue'], updatedVariableObject,
                parameterObject, functionMap, variableIdMap
            );
            updatedVariableObject = fallbackValue.variableObject;
            returnValue = dotNotationMapper(currentValue, path.value, true, fallbackValue.value);
        }else if(methodName === 'dotNotationSet'){
            let path = resolveExpression(
                methodData['path'], updatedVariableObject,
                parameterObject, functionMap, variableIdMap
            );
            updatedVariableObject = path.variableObject;
            let value = resolveExpression(
                methodData['value'], updatedVariableObject,
                parameterObject, functionMap, variableIdMap
            );
            updatedVariableObject = value.variableObject;
            returnValue = dotNotationObjectUpdate(currentValue, value.value, path.value);
        }

        return {
            value : returnValue,
            variableObject : updatedVariableObject
        }
    }catch(e){
        console.log('/utils/syncFunctionParser/simpleScript/expressionMethods/methodParser/variableCustomParamParser catch block error', e);
        return {
            value : undefined,
            variableObject 
        };
    }
}